module.exports = __webpack_public_path__ + "static/media/Record.22373028.webp";